// extracted by mini-css-extract-plugin
export default {"root":"DMgYdQ","line":"Bh6S2Z"};